import { DashboardBaseFilterModel } from '@/dashboard/models/DashboardBaseFilterModel'

export class DashboardAverageTicketFilterModel extends DashboardBaseFilterModel {
    constructor(d?:Partial<DashboardAverageTicketFilterModel>) {
        super(d)
    }
}
